import { render, staticRenderFns } from "./JpBanner.vue?vue&type=template&id=8932845e&scoped=true&"
import script from "./JpBanner.vue?vue&type=script&lang=js&"
export * from "./JpBanner.vue?vue&type=script&lang=js&"
import style0 from "./JpBanner.vue?vue&type=style&index=0&id=8932845e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8932845e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/button/index.vue').default})
